import { useMemo } from "react";
import { formatTimeShort } from "@scroll/shared-types/timeline-utils";

interface TimelineRulerProps {
  totalDuration: number;
  pixelsPerSecond: number;
}

export default function TimelineRuler({
  totalDuration,
  pixelsPerSecond,
}: TimelineRulerProps) {
  const marks = useMemo(() => {
    // Choose interval based on zoom level
    let interval: number;
    if (pixelsPerSecond > 80) interval = 1;
    else if (pixelsPerSecond > 30) interval = 5;
    else if (pixelsPerSecond > 15) interval = 10;
    else interval = 30;

    const result: { time: number; label: string; left: number }[] = [];
    for (let t = 0; t <= totalDuration; t += interval) {
      result.push({
        time: t,
        label: formatTimeShort(t),
        left: t * pixelsPerSecond,
      });
    }
    return result;
  }, [totalDuration, pixelsPerSecond]);

  return (
    <div
      className="timeline-ruler"
      style={{ width: `${totalDuration * pixelsPerSecond}px` }}
    >
      {marks.map((mark) => (
        <span
          key={mark.time}
          className="timeline-ruler-mark"
          style={{ left: `${mark.left}px` }}
        >
          {mark.label}
        </span>
      ))}
    </div>
  );
}
